export default "__VITE_ASSET__QpBHohA___"